'use client';

import { ReactNode, useEffect, useState } from 'react';

export const NoSSR: React.FC<{ children: ReactNode; fallback?: ReactNode }> = ({
    children,
    fallback,
}) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => setMounted(true), []);

    return mounted ? children : fallback;
};
